var map = {
	"./Mar_Fondo.mp4": "cccc",
	"./Mar_Fondo_Low.mp4": "18da",
	"./PortafolioReel-low.mp4": "d458",
	"./PortafolioReel-movil.mp4": "494f",
	"./VID03.mp4": "859f",
	"./placeholder.mp4": "89a8",
	"./placeholder_en.mp4": "781d",
	"./placeholder_movil.mp4": "ccc9",
	"./placeholder_movil_en.mp4": "c8ac"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8a9f";